<form [formGroup]="form" class="row">
  <!-- Caso Validacion Referencia  -->
  <mat-form-field class="col-6" appearance="outline">
    <mat-label>Especialista que Recibe Alerta</mat-label>
    <mat-select formControlName="especialista">
      <mat-option
        *ngFor="let especialista of especialistas"
        [value]="especialista.fullname"
        >{{ especialista.fullname }}</mat-option
      >
    </mat-select>
  </mat-form-field>
  <mat-form-field class="col-6" appearance="outline">
    <mat-label>I.D. del Operador de Alerta</mat-label>
    <input type="email" matInput formControlName="id_operador" />
  </mat-form-field>
  <mat-form-field class="col-12" appearance="outline">
    <mat-label>I.D. de la Agencia</mat-label>
    <input type="email" matInput formControlName="id_agencia" />
  </mat-form-field>
 
  <mat-form-field style="width: 100%" appearance="outline">
    <mat-label>Descripción de la Validación Realizada</mat-label>
    <textarea
      matInput
      placeholder="Describa la validación realizada"
      formControlName="descripcion"
    ></textarea>
  </mat-form-field>
</form>
